import React from "react";
import { RouterProvider } from "react-router-dom";
import "./styles/design-system.css";
import "./App.css";
import { AudioProvider } from "./contexts/AudioContext";
import { AuthProvider } from "./contexts/AuthContext";
import { DiskColorProvider } from "./contexts/DiskColorContext";
import { ImageProvider } from "./contexts/ImageContext";
import { SessionProvider } from "./contexts/SessionContext";
import { router } from "./routes/router";
import { DesignProvider } from './contexts/DesignContext';
import { ToastProvider } from './contexts/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <SessionProvider>
            <ImageProvider>
              <AudioProvider>
                <DiskColorProvider>
                  <DesignProvider>
                    <RouterProvider router={router}></RouterProvider>
                  </DesignProvider>
                </DiskColorProvider>
              </AudioProvider>
            </ImageProvider>
          </SessionProvider>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
